import { forwardRef } from 'react';

import type { ForwardRefRenderFunction, HTMLAttributes } from 'react';

export type InputFieldErrorProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  'className'
>;

const InputFieldErrorRenderFunction: ForwardRefRenderFunction<
  HTMLDivElement,
  InputFieldErrorProps
> = (attrs, ref) => {
  return <div {...attrs} ref={ref} className="text-sm text-error-100" />;
};

export const InputFieldError = forwardRef<HTMLDivElement, InputFieldErrorProps>(
  InputFieldErrorRenderFunction,
);
